import React from "react";
import AchievementV2 from "../achievementv2"; //Sponsors and Partners
import Achievev3 from "../achievev3"; //as MeetPlayers  
import AuthorV2 from "../authorv2";
import Authorv3  from "../authorv3";//as WhyRead }
import Booksv2 from "../booksv2";
import Chapterv2 from "../chapterv2";
import ChapterPreview from "../chapter-preview";
import Contact from "../contact";
import Ctav4 from "../ctav4";
import Ctav5 from "../ctav5";
import FunFacts from "../fun-facts";
import Footer from "../global/footer";
import Header from "../global/header";
import Hero from "../hero";
import Pricing from "../pricing";
import Testimonial from "../testimonial";


const Version00 = ({header, footer}) => {
  const {menuv0} = footer;

  return (
    <>
     <Header header={header} />
      <Hero isBg="yes" />
      <Authorv3 isBg=""/> {/* About*/}
      <Achievev3 isBg="yes"/> {/* Players*/}
      <Chapterv2 isBg="" />  {/* Parts */}
      {/* <Pricing isBg="yes" />*/}
      <Testimonial isBg="yes" /> 
      <AchievementV2 isBg="" />  {/* Supporters*/}
      {/*<Contact isBg="" /> */}
      <AuthorV2 isBg="yes" />
      
      {/* <ChapterPreview isBg="" />
    
      <FunFacts isBg=""/>
      <Booksv2 isBg="yes" />
      <Ctav5 isBg=""/>
      <Ctav4 isBg="" /> */}
      <Footer  isBg="" menu={menuv0} />
    </>
  );
}

export default Version00;
